import styled from 'styled-components';
import { spacing } from '@nubank/nuds-web/styles/themeUtils';

import Chip from '@nubank/www-latam-commons/components/Chip/Chip';

export const StyledChip = styled(Chip)`
  margin-right: ${spacing('4x')};
  display: inline-block;

  &:last-child {
    margin-right: 0;
  }
`;

StyledChip.displayName = 'StyledChip';
